import * as React from 'react'
import { dispatchToProps } from './InternetList.container'
import { Table, TableHeader, TableRow } from 'features/Table'
import Pagination from 'components/Pagination'
import EmptyMessageCard from 'components/Cards/EmptyMessageCard'
import { useGetInternetServicesQuery } from 'src/generated/graphql'
import LoadingOverlay from 'components/Loading/LoadingOverlay'
import Button from 'components/Button'
import * as sLay from 'styles/modules/layout.scss'
import cn from 'classnames'
import SelectPretty from 'components/Input/SelectPretty'
import * as sMarg from 'styles/modules/margins.scss'
import { Field } from 'redux-form'

export interface IInternetListComponent {
  page: number
  replace: typeof dispatchToProps['replace']
  formData: {
    type?: string
  }
}

const typeOptions = [
  {
    name: 'Any',
    value: '',
  },
  {
    name: 'Ethernet',
    value: 'Ethernet',
  },
  {
    name: 'Enterprise Ethernet',
    value: 'Enterprise Ethernet',
  },
  {
    name: 'Business Broadband',
    value: 'Business Broadband',
  },
  {
    name: 'DSL',
    value: 'DSL',
  },
  {
    name: '4G Broadband',
    value: '4G Broadband',
  },
]

export const InternetListComponent = (props: IInternetListComponent) => {
  const { page, replace, formData } = props

  const { data, loading } = useGetInternetServicesQuery({
    variables: { page, type: formData.type ? [formData.type] : undefined },
  })

  if (loading || !data) return <LoadingOverlay transparent />

  const { results, totalPages } = data.internetServices
  return (
    <div>
      <div className={cn(sMarg.mb30, sLay['layout-row'])}>
        <div className={sLay.flex} />
        <Field
          label="Type"
          component={SelectPretty}
          name="type"
          options={typeOptions}
          display="box"
        />
      </div>
      {results.length === 0 ? (
        <EmptyMessageCard
          title="You have no internet services"
          subtitle="Give us a call to find out more"
        />
      ) : (
        <div>
          <Table
            header={
              <TableHeader>
                <div>Usage Plan</div>
                <div>Billing Status</div>
                <div className={sLay['hide-xs']}>Service Number</div>
                <div className={sLay['hide-xs']}>Reference</div>
                <div style={{ maxWidth: '76px' }} />
              </TableHeader>
            }
          >
            {results.map(service => {
              return (
                <TableRow key={service.id}>
                  <div>{service.usagePlan}</div>
                  <div>{service.billingStatus}</div>
                  <div className={sLay['hide-xs']}>{service.number}</div>
                  <div className={sLay['hide-xs']}>{service.customerReference}</div>
                  <div style={{ maxWidth: '76px' }}>
                    <Button
                      color="tertiary"
                      size="xs"
                      ghost
                      to={`/dashboard/internet/${service.id}`}
                    >
                      View
                    </Button>
                  </div>
                </TableRow>
              )
            })}
          </Table>
        </div>
      )}
      <Pagination
        page={page}
        numPages={totalPages}
        onClick={nextPage =>
          replace({
            pathname: location.pathname,
            query: {
              page: nextPage,
            },
          })
        }
      />
    </div>
  )
}



// WEBPACK FOOTER //
// src/features/Internet/InternetList/InternetList.tsx